import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts'

function CallChart({ data }) {
  if (!data || data.length === 0) {
    return (
      <div className="h-64 flex items-center justify-center text-primary-500">
        No data available
      </div>
    )
  }

  // Transform data for chart
  const chartData = data.map(item => ({
    date: item._id,
    totalCalls: item.totalCalls,
    completedCalls: item.completedCalls
  }))

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-white p-3 border border-primary-200 rounded-lg shadow-sm">
          <p className="text-sm font-medium text-primary-900">{`Date: ${label}`}</p>
          <p className="text-sm text-blue-600">{`Total Calls: ${payload[0].value}`}</p>
          <p className="text-sm text-green-600">{`Completed: ${payload[1].value}`}</p>
        </div>
      )
    }
    return null
  }

  return (
    <div className="h-64">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={chartData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
          <XAxis 
            dataKey="date" 
            stroke="#6b7280"
            fontSize={12}
            tickLine={false}
            axisLine={false}
          />
          <YAxis 
            stroke="#6b7280"
            fontSize={12}
            tickLine={false}
            axisLine={false}
          />
          <Tooltip content={<CustomTooltip />} />
          <Bar dataKey="totalCalls" fill="#3b82f6" radius={[2, 2, 0, 0]} />
          <Bar dataKey="completedCalls" fill="#10b981" radius={[2, 2, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  )
}

export default CallChart